import gql from 'graphql-tag';

export default gql`
  query indexPageImages {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          paypalEnabled
          paypalBannersEnabled
        }
        images(section: "paypal") {
          id
          path
          alt
          title
        }
      }
    }
  }
`;
